import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-not-found',
  standalone: true,
  imports: [],
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.css'
})
export class NotFoundComponent {
  constructor(private route: ActivatedRoute, private router: Router) { }
  
  gotoHome(){
    this.router.navigate(['/admin/login']);
  }
}
